export const UserConst = {
  displayedColumns: [
    'company_name',
    'name',
    'role_name',
    'contact_email',
    'login_date',
    'status_name',
    'action',
  ],
};

export const PartyConst = {
  displayedColumns: [
    'persona_name',
    'country_name',
    'company_party_name',
    'action',
  ],
};

export const UserActivitiesConst = {
  displayedColumns: ['date', 'action', 'event'],
};

export const TradeLaneConst = {
  displayedColumns: [
    'name',
    'company_name',
    'pol_code',
    // 'pol_country',
    'pod_code',
    // 'pod_country',
    'reta_to',
    // 'flow_count',
    'product_no',
    'status',
    'action',
  ],
};

export const TradeLaneFlowConst = {
  displayedColumns: ['name', 'steps', 'status'],
};

export const RoleConst = {
  displayedColumns: ['name', 'company_name', 'collar_type_name', 'description', 'user_count', 'status', 'action'],
};

export const CompanyConst = {
  displayedColumns: ['name', 'persona', 'country_name', 'licence_type_name', 'invited', 'inactive', 'active', 'status', 'action'],
};

export const Type = {
  user: 'user_management',
  trade_lane: 'trade_lane_management',
  company: 'company_management',
  flow: 'flow_management',
  role: 'role_management',
  party: 'party_management',
  category: 'category_management',
  licence: 'licence_management'
};

export const CompanyPersona = {
  displayedColumns: ['type', 'name', 'address', 'country', 'location_link', 'status', 'action'],
};

export const Flow = {
  displayedColumns: [
    'trade_lane',
    'name',
    'company',
    'pol_code',
    'pod_code',
    'steps',
    'personas',
    'groups',
    'status',
    'action',
  ],
};
